import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/api`;
function api(path, opts = {}) {
  const token = localStorage.getItem('token');
  return fetch(`${API_BASE_URL}${path}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, ...opts.headers },
  }).then(async r => {
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.message || d.error || `HTTP ${r.status}`);
    return d;
  });
}

const wrap = { minHeight: '100vh', backgroundColor: '#0f172a', color: '#e2e8f0', fontFamily: 'sans-serif', padding: 20 };

export default function MaterialDropoff() {
  const { locationId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    api(`/materials/dropoff/${locationId}`)
      .then(d => { setData(d); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, [locationId]);

  const complete = async () => {
    setBusy(true);
    try { const r = await api(`/materials/dropoff/${locationId}/complete`, { method: 'POST' }); setResult(r); }
    catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };

  if (loading) return <div style={wrap}>Loading…</div>;
  if (error) return <div style={{ ...wrap, color: '#fca5a5' }}>Could not load: {error}<div style={{ color: '#64748b', fontSize: 13, marginTop: 8 }}>Make sure you are logged in to FieldCore on this device.</div></div>;
  if (!data) return <div style={{ ...wrap, color: '#fca5a5' }}>Stock location not found.</div>;

  return (
    <div style={wrap}>
      <div style={{ maxWidth: 480, margin: '0 auto' }}>
        <div style={{ fontSize: 13, color: '#64748b', letterSpacing: 1, marginBottom: 6 }}>📥 RETURN TO STOCK</div>
        <div style={{ fontSize: 22, fontWeight: 800, marginBottom: 16 }}>{data.stock_location?.name}</div>

        {result ? (
          <div style={{ textAlign: 'center', padding: 28, backgroundColor: '#0d2818', border: '1px solid #16632a', borderRadius: 10 }}>
            <div style={{ fontSize: 48 }}>✅</div>
            <div style={{ fontWeight: 800, fontSize: 20, color: '#4ade80', marginTop: 6 }}>Returned to stock</div>
            <div style={{ color: '#94a3b8', fontSize: 14, marginTop: 8 }}>{result.items} item{result.items === 1 ? '' : 's'} returned · {result.miles} mi logged to the capital WO</div>
            <div style={{ color: '#64748b', fontSize: 12, marginTop: 6 }}>Your return task is complete and your timesheet is updated.</div>
          </div>
        ) : (data.items || []).length === 0 ? (
          <div style={{ textAlign: 'center', padding: 24, color: '#fbbf24', backgroundColor: '#3a2e0a', border: '1px solid #854d0e', borderRadius: 10 }}>No pending return found for you.</div>
        ) : (
          <>
            <div style={{ backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: 10, padding: 16, marginBottom: 16 }}>
              <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>The system is expecting these back:</div>
              {data.items.map(i => (
                <div key={i.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #0f172a', fontSize: 14 }}>
                  <span>{i.description}</span><span style={{ fontWeight: 700 }}>{i.qty_to_return} {i.unit || ''}</span>
                </div>
              ))}
            </div>
            <button onClick={complete} disabled={busy} style={{ width: '100%', padding: 16, backgroundColor: '#166534', color: '#dcfce7', border: 'none', borderRadius: 8, fontWeight: 800, fontSize: 16, cursor: 'pointer' }}>{busy ? 'Returning…' : 'Confirm Drop-off'}</button>
          </>
        )}
      </div>
    </div>
  );
}
